{
  "account.backToSignIn": "Retour à la connexion",
  "account.birthDate": "Date de naissance",
  "account.birthDateHint": "Un festival ne s'accompagne pas seul avant l'âge requis dans ton pays.",
  "account.childProfile": "Profil enfant",
  "account.country": "Pays",
  "account.countryOption": "Pays : {{name}}",
  "account.day": "Jour",
  "account.dayShort": "JJ",
  "account.delete": "Supprimer mon compte",
  "account.deleteConfirm": "Supprimer définitivement",
  "account.deleteExplain": "Ton compte, tes groupes, tes positions partagées et tes relevés seront effacés, ainsi que les profils enfants rattachés. C'est définitif. Le programme, tes favoris et tes repères restent sur ce téléphone.",
  "account.deletePasswordHint": "Saisis ton mot de passe pour confirmer.",
  "account.deleted": "Ton compte a été supprimé.",
  "account.displayName": "Nom affiché",
  "account.email": "Adresse électronique",
  "account.forgot": "Mot de passe oublié ?",
  "account.invalidCredentials": "Adresse ou mot de passe incorrect.",
  "account.invitationCode": "Code d'invitation",
  "account.invitationHint": "L'inscription n'est pas ouverte : un compte se crée avec un code remis par quelqu'un.",
  "account.invitationInvalid": "Ce code d'invitation n'est pas valable.",
  "account.invitationScanned": "Invitation reconnue : complète le formulaire.",
  "account.month": "Mois",
  "account.monthShort": "MM",
  "account.newPassword": "Nouveau mot de passe",
  "account.open": "Compte",
  "account.password": "Mot de passe",
  "account.passwordHint": "Douze caractères au minimum.",
  "account.registrationFailed": "L'inscription n'a pas pu aboutir. Vérifie les informations saisies.",
  "account.resetCode": "Code reçu",
  "account.resetConfirm": "Changer le mot de passe",
  "account.resetDone": "Mot de passe changé. Connecte-toi avec le nouveau.",
  "account.resetExplain": "Saisis l'adresse de ton compte : nous y envoyons un code à six chiffres.",
  "account.resetInvalid": "Ce code n'est pas valable, ou il a expiré. Demandes-en un nouveau.",
  "account.resetSend": "Recevoir un code",
  "account.resetSent": "Si un compte utilise cette adresse, un code vient d'y être envoyé. Il est valable 15 minutes.",
  "account.signIn": "Se connecter",
  "account.signOut": "Se déconnecter",
  "account.signUp": "Créer un compte",
  "account.signedInAs": "Connecté en tant que {{name}}",
  "account.title": "Mon compte",
  "account.toggleToSignIn": "J'ai déjà un compte",
  "account.toggleToSignUp": "Je n'ai pas encore de compte",
  "account.tooMany": "Trop d'essais. Réessaie dans quelques minutes.",
  "account.tooYoung": "Le compte doit être créé par un adulte, qui pourra ensuite y rattacher un profil enfant.",
  "account.unreachable": "Serveur injoignable. Réessaie une fois le réseau revenu.",
  "account.year": "Année",
  "account.yearShort": "AAAA",
  "aerial.download": "Télécharger le fond aérien",
  "aerial.downloading": "Téléchargement…",
  "aerial.explain": "Une vue aérienne du site, prise par drone. Elle occupe {{size}} Mo sur ton téléphone et se télécharge une seule fois.",
  "aerial.failed": "Téléchargement impossible. Réessaie en Wi-Fi.",
  "aerial.ready": "Fond aérien disponible hors ligne",
  "aerial.remove": "Effacer le fond aérien",
  "aerial.title": "Fond aérien",
  "aerial.wifiHint": "À faire de préférence avant d'arriver, en Wi-Fi.",
  "common.cancel": "Annuler",
  "common.close": "Fermer",
  "common.retry": "Réessayer",
  "common.search": "Rechercher",
  "crew.apiUnavailable": "Groupe indisponible : aucun serveur configuré",
  "crew.background.active": "Ta position part aussi téléphone en poche, environ une fois par minute quand tu bouges.",
  "crew.background.allow": "Autoriser la position en permanence",
  "crew.background.foregroundOnly": "Tes amis te voient seulement quand l'appli est ouverte.",
  "crew.background.notificationBody": "Jusqu'à {{time}}. Ouvre l'appli pour arrêter.",
  "crew.background.notificationTitle": "Position partagée avec {{crew}}",
  "crew.codeLabel": "Code du groupe",
  "crew.create": "Créer un groupe",
  "crew.error.festival": "Ce festival n'est pas encore sur le serveur : impossible d'y créer un groupe.",
  "crew.error.notFound": "Aucun groupe ne porte ce code. Vérifie-le auprès de la personne qui a créé le groupe.",
  "crew.error.notMember": "Tu ne fais plus partie de ce groupe, ou il a expiré.",
  "crew.error.refused": "Le serveur a refusé la demande. Réessaie plus tard.",
  "crew.error.session": "Ta session a expiré. Reconnecte-toi.",
  "crew.error.tooMany": "Trop d'essais. Réessaie dans quelques minutes.",
  "crew.join": "Rejoindre avec un code",
  "crew.lastSeen": "Vu il y a {{minutes}} min",
  "crew.lastSeenDays": "Vu il y a {{days}} j",
  "crew.lastSeenHours": "Vu il y a {{hours}} h",
  "crew.nameLabel": "Nom du groupe",
  "crew.near": "Près de {{place}}",
  "crew.needAccount": "Un compte est nécessaire pour rejoindre un groupe",
  "crew.noCrew": "Aucun groupe pour l'instant",
  "crew.noPosition": "Ne partage pas sa position",
  "crew.offline": "Hors ligne — dernières informations connues",
  "crew.positionStale": "Position ancienne",
  "crew.rallyNeedPosition": "Active ta position pour savoir où c'est",
  "crew.rallyOnMap": "RDV du groupe",
  "crew.rallySetAt": "Posé à {{time}}",
  "crew.section.members": "Le groupe",
  "crew.section.sharing": "Ma position",
  "crew.setRally": "Définir un point de rendez-vous ici",
  "crew.shareCode": "Fais scanner ce code, ou dicte-le",
  "crew.shareOff": "Partage de position désactivé",
  "crew.sharing.APPROXIMATE": "Zone approximative",
  "crew.sharing.OFF": "Ne pas partager",
  "crew.sharing.PRECISE": "Position précise",
  "crew.sharingFor": "Partager {{hours}} h",
  "crew.sharingUntil": "Partage actif jusqu'à {{time}}",
  "crew.showOnMap": "Voir sur le plan",
  "crew.title": "Mon groupe",
  "crew.you": "C'est toi",
  "diary.empty": "Aucun concert marqué pour l'instant",
  "diary.markSeen": "J'y étais",
  "diary.notYet": "Pas encore commencé",
  "diary.photosCount": "{{count}} photo(s) prises pendant le festival",
  "diary.photosDenied": "Accès aux photos refusé",
  "diary.photosExplain": "Les photos restent sur ton téléphone : rien n'est copié ni envoyé.",
  "diary.photosNone": "Aucune photo trouvée sur cette période",
  "diary.photosPermission": "Autoriser l'accès aux photos",
  "diary.photosTitle": "Photos de ce festival",
  "diary.stats": "{{performances}} concert(s) · {{artists}} artiste(s) · {{days}} jour(s)",
  "diary.unmarkSeen": "Retirer du carnet",
  "festival.checkedOn": "vérifié le {{date}}",
  "festival.reportHint": "Une erreur ? Touche ce bandeau, ou appuie longuement sur un concert ou un lieu.",
  "festival.source": "Programme repris de : {{source}}",
  "festival.unofficial": "Page non officielle : informations non vérifiées par l'organisateur.",
  "keyring.add": "Ajouter un festival",
  "keyring.already": "Déjà dans tes festivals",
  "keyring.change": "Changer de festival",
  "keyring.current": "Festival ouvert",
  "keyring.empty": "Aucun festival ajouté pour l'instant.",
  "keyring.noResult": "Aucun festival trouvé.",
  "keyring.offline": "Recherche impossible sans réseau. Les festivals déjà ajoutés restent consultables.",
  "keyring.pinFailed": "Ton téléphone n'a pas pu ajouter l'icône.",
  "keyring.pinHint": "Une icône pour ce festival, qui ouvre l'appli directement dessus.",
  "keyring.pinShortcut": "Ajouter à l'écran d'accueil",
  "keyring.remove": "Retirer",
  "keyring.removed": "Festival retiré. Son contenu hors ligne a été effacé.",
  "keyring.search": "Nom du festival ou de la ville",
  "keyring.searchHint": "Tu peux aussi scanner ton billet : le festival s'ajoute tout seul.",
  "keyring.title": "Mes festivals",
  "lineup.all": "Tout le programme",
  "lineup.cancelled": "Annulé",
  "lineup.conflict": "Chevauche un autre concert de tes favoris",
  "lineup.conflictLine": "{{first}} et {{second}} se chevauchent de {{minutes}} min",
  "lineup.conflictsTitle": "{{count}} chevauchement(s) entre tes favoris",
  "lineup.delayed": "Retardé",
  "lineup.favorite": "Ajouter à mes favoris",
  "lineup.favoritesOnly": "Mes favoris",
  "lineup.noPerformances": "Aucun concert au programme",
  "lineup.reminderBody": "{{artist}} dans {{minutes}} min · {{stage}}",
  "lineup.reminderTitle": "Ça commence bientôt",
  "lineup.remindersPlanned": "{{count}} rappel(s) programmé(s)",
  "lineup.remindersUnavailable": "Rappels indisponibles — notifications refusées",
  "lineup.removeFavorite": "Retirer des favoris",
  "lineup.title": "Programmation",
  "location.denied": "Position refusée — le plan reste utilisable",
  "location.granted": "Position activée",
  "mail.reset.body": "Bonjour {{name}},\n\nVoici ton code pour choisir un nouveau mot de passe Festipal :\n\n{{code}}\n\nIl est valable {{minutes}} minutes. Si tu n'as rien demandé, ignore ce message : ton mot de passe ne change pas.\n\nFestipal",
  "mail.reset.subject": "Ton code Festipal : {{code}}",
  "map.bearing.east": "vers l'est",
  "map.bearing.north": "vers le nord",
  "map.bearing.northeast": "vers le nord-est",
  "map.bearing.northwest": "vers le nord-ouest",
  "map.bearing.south": "vers le sud",
  "map.bearing.southeast": "vers le sud-est",
  "map.bearing.southwest": "vers le sud-ouest",
  "map.bearing.west": "vers l'ouest",
  "map.closeDetail": "Fermer",
  "map.distanceMeters": "à {{distance}} m",
  "map.listView": "Voir la liste des lieux",
  "map.loadError": "Le plan n'a pas pu être chargé",
  "map.loading": "Préparation du plan…",
  "map.locateMe": "Me localiser",
  "map.offlineBadge": "Plan hors ligne",
  "map.offlineNotice": "Plan disponible hors ligne",
  "map.tapHint": "Touche un point du plan pour savoir ce que c'est.",
  "map.title": "Plan du site",
  "marker.car": "Ma voiture",
  "marker.dropHere": "Poser un repère ici",
  "marker.meeting": "Point de rendez-vous",
  "marker.needLocation": "Position nécessaire pour poser un repère",
  "marker.other": "Repère",
  "marker.remove": "Retirer ce repère",
  "marker.tent": "Ma tente",
  "me.account": "Mon compte",
  "me.accountAnonymous": "Pas encore de compte",
  "me.diary": "Mon carnet",
  "me.diaryCount": "{{count}} concert(s) vu(s)",
  "me.festivals": "Mes festivals",
  "me.festivalsCount": "{{count}} festival(s) ajouté(s)",
  "me.scan": "Scanner un code",
  "me.scanHint": "Billet, invitation ou groupe",
  "me.survey": "Arpenter le site",
  "me.surveyHint": "Relever les lieux manquants",
  "me.title": "Moi",
  "ping.age": "Il y a {{minutes}} min",
  "ping.cancel": "On s'est retrouvés",
  "ping.channel": "Appels du groupe",
  "ping.from": "{{name}} : « Rejoins-moi ! »",
  "ping.notificationBody": "Touche pour voir où.",
  "ping.notificationTitle": "{{name}} : « Rejoins-moi ! »",
  "ping.onMap": "Rejoindre {{name}}",
  "ping.send": "Rejoins-moi : envoyer ma position",
  "ping.sendHint": "Ta position exacte part à ton groupe, pour {{minutes}} min.",
  "ping.sent": "Tu as appelé ton groupe à {{time}}, jusqu'à {{until}}.",
  "places.allCategories": "Toutes",
  "places.awaitingLocation": "Position en cours d'acquisition…",
  "places.count": "{{count}} lieu(x)",
  "places.direction": "{{distance}} m {{bearing}} · {{minutes}} min à pied",
  "places.fromHere": "Calculer les distances depuis ce lieu",
  "places.locationUnavailable": "Position indisponible — lieux classés par nom",
  "places.noResult": "Aucun lieu ne correspond",
  "places.originDevice": "Distances depuis ma position",
  "places.originManual": "Distances depuis {{place}}",
  "places.pickOrigin": "Choisir un point de repère dans la liste",
  "places.searchPlaceholder": "Chercher un lieu",
  "places.title": "Lieux",
  "places.unverified": "Non vérifié",
  "places.useMyLocation": "Utiliser ma position",
  "poi.category.accessible": "Accès PMR",
  "poi.category.bar": "Bar",
  "poi.category.charging": "Recharge téléphone",
  "poi.category.entrance": "Entrée",
  "poi.category.exit": "Sortie de secours",
  "poi.category.firstaid": "Poste de secours",
  "poi.category.food": "Restauration",
  "poi.category.info": "Point info",
  "poi.category.lockers": "Consigne",
  "poi.category.stage": "Scène",
  "poi.category.toilets": "Toilettes",
  "poi.category.water": "Point d'eau",
  "report.comment": "Précise si tu veux (facultatif)",
  "report.failed": "Envoi refusé. Réessaie plus tard.",
  "report.festival": "Le programme ou le plan en général",
  "report.kind.CANCELLED": "Annulé",
  "report.kind.GONE": "N'existe pas ou plus",
  "report.kind.MISSING": "Il manque un concert ou un lieu",
  "report.kind.OTHER": "Autre chose",
  "report.kind.WRONG_PLACE": "Mal placé",
  "report.kind.WRONG_STAGE": "Mauvaise scène",
  "report.kind.WRONG_TIME": "Mauvais horaire",
  "report.offline": "Hors ligne : rien n'est parti. Réessaie quand le réseau revient.",
  "report.openSource": "Voir la source",
  "report.send": "Envoyer",
  "report.sent": "Merci ! C'est transmis à qui tient cette page.",
  "report.title": "Signaler une erreur",
  "report.tooMany": "Trop de signalements d'un coup. Réessaie dans quelques minutes.",
  "safety.callEmergency": "Appeler les secours",
  "safety.emergencyTitle": "Assistance et secours",
  "safety.nearestFirstAid": "Poste de secours le plus proche",
  "scan.close": "Fermer le scanner",
  "scan.crewFound": "Groupe reconnu : {{code}}",
  "scan.festivalFound": "Festival reconnu : {{slug}}",
  "scan.hint": "Scanne ton billet ou le code d'un groupe",
  "scan.invitationFound": "Invitation reconnue",
  "scan.open": "Scanner un code",
  "scan.permission": "Autoriser la caméra",
  "scan.permissionDenied": "Caméra refusée — saisis le code à la main",
  "scan.privacy": "Seul l'identifiant du festival est lu. Rien d'autre du billet n'est conservé.",
  "scan.title": "Scanner",
  "scan.unknown": "Code non reconnu. S'il vient d'une billetterie, cherche ton festival dans la liste.",
  "shortcut.add": "Ajouter",
  "shortcut.later": "Plus tard",
  "shortcut.offer": "Ajouter {{name}} à ton écran d'accueil ?",
  "survey.addPhoto": "Ajouter une photo",
  "survey.category": "Type de lieu",
  "survey.comment": "Précision utile (facultatif)",
  "survey.intro": "Marche jusqu'au lieu à relever, reste immobile le temps de la mesure, puis nomme-le.",
  "survey.measuring": "{{used}} mesures retenues · précision {{accuracy}} m",
  "survey.moderationNotice": "Chaque relevé est relu avant d'apparaître dans l'application.",
  "survey.name": "Nom du lieu",
  "survey.needAccount": "Un compte est nécessaire : un relevé est attribué à son auteur.",
  "survey.needLocation": "L'accès à la position est nécessaire pour relever un point.",
  "survey.open": "Arpenter",
  "survey.photoAttached": "Photo jointe",
  "survey.photoRejected": "Photo écartée par le filtre automatique. Le relevé, lui, a bien été envoyé.",
  "survey.queue": "Mes relevés",
  "survey.queueEmpty": "Aucun relevé pour l'instant.",
  "survey.rejected": "{{count}} mesure(s) écartée(s), trop éloignée(s) des autres",
  "survey.removePhoto": "Retirer la photo",
  "survey.save": "Enregistrer le relevé",
  "survey.send": "Envoyer maintenant",
  "survey.sendFailed": "Envoi impossible pour l'instant. Les relevés restent sur l'appareil.",
  "survey.sending": "Envoi en cours…",
  "survey.start": "Commencer la mesure",
  "survey.statusPending": "En attente de réseau",
  "survey.statusRejected": "Relevé refusé par le serveur.",
  "survey.statusSent": "Envoyé",
  "survey.stop": "Arrêter la mesure",
  "survey.title": "Arpentage",
  "survey.tooImprecise": "Précision encore insuffisante. Éloigne-toi des structures métalliques et patiente.",
  "survey.waiting": "En attente du GPS…",
  "tab.crew": "Groupe",
  "tab.diary": "Carnet",
  "tab.lineup": "Programme",
  "tab.map": "Plan",
  "tab.me": "Moi",
  "tab.places": "Lieux"
}
